module.exports = __webpack_public_path__ + "static/media/logo-przelewy-24.a9880db1.svg";